<template>
  <div class="overviewappusers-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :inline="true">
          <el-form-item :label="$t('operate.name1')" prop="tenantId" v-if="userinfo.tenantType === 0 || userinfo.tenantType === 1">
            <el-cascader ref="refHandle" v-model="tenantIds" :placeholder="$t('public.name1')" :options="cascaderOptions" @change="handleChange" :props="{ lazy: true, lazyLoad: loadOptions }" clearable></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('operate.name2')" prop="keyword">
            <el-input v-model="queryInfo.keyword" :placeholder="$t('public.name28')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('operate.name38')" prop="status">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')">
              <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="bt-layout">
        <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
      </div>
          </el-form-item>
      </el-form>
    </div>
    <!-- <div>
      <el-button type="primary" size="medium" @click="pushMessage(1)" v-if="userinfo.tenantType !==0">推送消息</el-button>
      <el-button type="primary" size="medium" @click="pushMessage(2)" v-if="userinfo.tenantType !==0">推送全部用户</el-button>
    </div> -->
    <el-table  v-if="userinfo.tenantType === 0 || userinfo.tenantType === 1" :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('operate.name42')" prop="loginName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name39')" prop="tenantName" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.tenantName">{{ scope.row.parentTenantName }}>{{ scope.row.tenantName }} </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name43')" prop="tenantType" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.tenantType === 20">{{ $t('manage.name120') }}</div>
          <div v-if="scope.row.tenantType === 21">{{ $t('manage.name121') }}</div>
          <div v-if="scope.row.tenantType === 22">{{ $t('manage.name129') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name5')" prop="appName" sortable></el-table-column>
      <el-table-column :label="$t('operate.name44')" prop="nickName" sortable></el-table-column>
      <el-table-column :label="$t('operate.name45')" prop="userCode" sortable></el-table-column>
      <el-table-column :label="$t('operate.name46')" prop="headPicUrl" sortable>
        <template slot-scope="scope">
          <el-image v-if="scope.row.headPicUrl" style="width: 60px; height: 60px" :src="scope.row.headPicUrl" :preview-src-list="[scope.row.headPicUrl]"></el-image>
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name47')" prop="createTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.createTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name23')" prop="status" sortable>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-color="#0f73e6" inactive-color="#dcdfe6" @change="changeSwitch(scope.row, $event)"> </el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name22')" width="140px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="associatedVehicles(scope.row)">{{ $t('operate.name49') }}</el-button>
          <!-- <el-button type="text" @click="resetPassword(scope.row)">{{ $t('operate.name50') }}</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-table v-else ref="table"  :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading" @selection-change="onSelectTab">
      <el-table-column type="selection"  width="55"></el-table-column>
      <el-table-column :label="$t('operate.name155')" prop="loginName" sortable></el-table-column>
      <el-table-column :label="$t('operate.name156')" prop="nickName" sortable> </el-table-column>
      <el-table-column :label="$t('operate.name157')" prop="tenantType" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.tenantType === 20">{{ $t('manage.name120') }}</div>
          <div v-if="scope.row.tenantType === 21">{{ $t('manage.name121') }}</div>
          <div v-if="scope.row.tenantType === 22">{{ $t('manage.name129') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name158')" prop="userCode" sortable></el-table-column>
      <el-table-column :label="$t('operate.name46')" prop="headPicUrl" sortable>
        <template slot-scope="scope">
          <img :src="scope.row.headPicUrl" />
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name159')" prop="phone" sortable></el-table-column>
      <el-table-column :label="$t('operate.name23')" prop="status" sortable>
        <template slot-scope="scope">
          <div class="qiyong" v-if="scope.row.status">
            <div class="text">{{ $t('manage.name13') }}</div>
          </div>
          <div class="jinyong" v-else>
            <div class="text">{{ $t('manage.name14') }}</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <AppDialog width="488px" :title="$t('operate.name50') " :visible.sync="dialogVisible" v-if="dialogVisible" :before-close="handleClose">
      <el-form ref="passwordFormRef" :model="passwordInfo" :rules="passwordFormRules" size="medium" :label-width="formLabelWidth()">
        <el-col :span="24">
          <el-form-item :label="$t('operate.name164')" prop="newpwd">
            <el-input v-model="passwordInfo.newpwd" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('operate.name165')" prop="confimPassword">
            <el-input v-model="passwordInfo.confimPassword" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('public.name14') }}</el-button>
        <el-button type="primary" @click="chanePassWord">{{ $t('public.name25') }}</el-button>
      </span>
    </AppDialog>
    <AppDialog size="lg" width="50%" :title="$t('operate.name49')" :visible.sync="associatedVehiclesDialog" v-if="associatedVehiclesDialog" :before-close="handleClose">
      <el-table :data="eBikeInfoList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading1">
      <el-table-column :label="$t('bike.name38')" prop="ebikeId" sortable></el-table-column>
      <el-table-column :label="$t('operate.name160')" prop="createTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.createTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name4')" prop="ebikeModelId" sortable></el-table-column>
      <el-table-column :label="$t('operate.name22')">
        <template slot-scope="scope">
          <el-button type="text" @click="unBindingEbike(scope.row)">{{ $t('bike.name114') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    </AppDialog>
    <AppDialog width="488px" :title="$t('operate.name162')" :visible.sync="pushMessageDialog" v-if="pushMessageDialog" :before-close="handleClose">
      <el-form ref="pushMessageFormRef" :model="pushMessageInfo" :rules="pushMessageFormRules" size="medium" :label-width="formLabelWidth()">
          <el-form-item :label="$t('operate.name163')" prop="context">
            <el-input v-model="pushMessageInfo.context" type="textarea" :rows="3" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('public.name14') }}</el-button>
        <el-button type="primary" @click="sumbmitPushMessage" :loading="loading">{{ $t('public.name25') }}</el-button>
      </span>
    </AppDialog>

  </div>
</template>
<script>
import { appUserList, appUserUpdateStatus, updateAppPwd, appUserEbikeList, pushMsgToUser, pushMsgToAllUser } from '@/api/operate.js'
import { cancelBindEbike } from '@/api/bike.js'
import { tenantList } from '@/api/manage.js'
import { mapGetters } from 'vuex'
import AppDialog from '@/components/AppDialog/index.vue'
export default {
  components: { AppDialog },
  computed: {
    ...mapGetters(['userinfo']),
    statusOption () {
      return [
        { value: 2, label: this.$t('operate.name98') },
        { value: 0, label: this.$t('operate.name48') },
        { value: 1, label: this.$t('operate.name39') }
      ]
    }
  },
  data() {
    return {
      tenantIds: [],
      cascaderOptions: [],
      associatedVehiclesDialog: false,
      eBikeInfoList: [],
      tableLoading1: false,
      tableLoading: false,
      dialogVisible: false,
      passwordInfo: {
        userId: '',
        newpwd: '',
        confimPassword: ''
      },
      pushMessageInfo: {
        context: ''
      },
      loading: false,
      pushMessageFormRules: {
        context: [
          {
            required: true,
            message: this.$t('screen.name5'),
            trigger: 'blur'
          }
        ]
      },
      passwordFormRules: {
        newpwd: [
          {
            required: true,
            message: this.$t('screen.name6'),
            trigger: 'blur'
          }
        ],

        confimPassword: [
          {
            required: true,
            message: this.$t('screen.name7'),
            trigger: 'blur'
          }
        ]
      },
      queryInfo: {
        keyword: '',
        page: 1,
        limit: 10,
        status: 2,
        tenantId: ''
      },
      tableList: [],
      total: 0,
      selectList: [],
      userInfoRules: {
        account: [
          {
            required: true,
            message: this.$t('screen.name8'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('login.name3'),
            trigger: 'blur'
          }
        ]
      },
      userInfo: {
        account: '',
        password: '',
        name: '',
        nikeName: '',
        tel: '',
        email: '',
        status: '1'
      },
      showMsgVisible: false,
      rolesInfo: {
        roles: ''
      },
      unbindId: '',
      showMsgallVisible: false,
      selectionList: [],
      pushMessageDialog: false,
      type: 1
    }
  },
  created() {
  },
  mounted() {
    this.queryList()
  },
  methods: {
    bindingRoles(row) {
      this.bindingRolesDialog = true
    },

    associatedVehicles(row) {
      this.unbindId = row.userId
      this.associatedVehiclesDialog = true
      this.getAppUserEbikeList()
    },

    getAppUserEbikeList() {
      const data = {
        userId: this.unbindId
      }
      this.tableLoading1 = true
      appUserEbikeList(data)
        .then(res => {
          this.eBikeInfoList = res.data
          this.tableLoading1 = false
        })
        .catch(() => {
          this.eBikeInfoList = []
          this.tableLoading1 = false
        })
    },

    resetQuery() {
      this.queryInfo = {
        keyword: '',
        page: 1,
        limit: 10,
        status: 2,
        tenantId: ''
      }
      this.tenantIds = []
      this.queryList()
    },
    getPageList() {
      this.queryInfo.limit = 10
      this.queryInfo.page = 1
      this.queryList()
    },
    queryList() {
      this.tableLoading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit
      }
      if (this.queryInfo.tenantId) {
        data.tenantId = this.queryInfo.tenantId
      }
      if (this.queryInfo.keyword) {
        data.keyword = this.queryInfo.keyword.trim()
      }
      if (this.queryInfo.status !== 2) {
        data.status = this.queryInfo.status === 0
      }
      appUserList(data)
        .then(res => {
          this.tableList = res.data.list
          this.total = res.data.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableList = []
          this.total = 0
          this.tableLoading = false
        })
    },

    unBindingEbike(row) {
      this.$confirm(this.$t('screen.name9'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          cancelBindEbike({ ebikeId: row.ebikeId }).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: this.$t('bike.name385')
              })
              this.getAppUserEbikeList()
            }
          }).catch(() => {})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('bike.name386')
          })
        })
    },

    changeSwitch(row, e) {
      this.tableLoading = true
      appUserUpdateStatus({ id: row.userId })
        .then(res => {
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },

    resetPassword(row) {
      this.passwordInfo.userId = row.userId
      this.dialogVisible = true
    },
    handleClose() {
      this.passwordInfo = {
        userId: '',
        newpwd: '',
        confimPassword: ''
      }
      this.dialogVisible = false
      this.pushMessageDialog = false
      this.associatedVehiclesDialog = false
      this.pushMessageInfo = {
        context: ''
      }
    },
    loadOptions(node, resolve) {
      // console.log('===', node)
      if (node.level === 2) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 1
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    handleChange(value) {
      // 处理选项变化
      this.queryInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
      this.getPageList()
    },

    chanePassWord() {
      this.$refs.passwordFormRef.validate(valid => {
        if (valid) {
          updateAppPwd(this.passwordInfo)
            .then((res) => {
              if (res.code === 200) {
                this.handleClose()
                this.$message({
                  type: 'success',
                  message: this.$t('screen.name10')
                })
              }
            })
            .catch(() => {})
        } else {
          return false
        }
      })
    },
    onSelectTab(selection) {
      this.selectionList = selection
    },
    pushMessage(type) {
      this.type = type
      if (this.type === 1) {
        if (this.selectionList.length > 0) {
          this.pushMessageDialog = true
        } else {
          this.$message.warning(this.$t('screen.name11'))
        }
      } else {
        this.pushMessageDialog = true
      }
    },
    sumbmitPushMessage() {
      this.$refs.pushMessageFormRef.validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.type === 1) {
            const ids = []
            this.selectionList.map((item) => {
              ids.push(item.userId)
            })
            this.pushMessageInfo.userIds = ids.join(',')
            pushMsgToUser(this.pushMessageInfo)
              .then((res) => {
                this.loading = false
                if (res.code === 200) {
                  this.$refs.table.clearSelection()
                  this.handleClose()
                  this.$message({
                    type: 'success',
                    message: this.$t('screen.name12')
                  })
                }
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            pushMsgToAllUser(this.pushMessageInfo)
              .then((res) => {
                this.loading = false
                if (res.code === 200) {
                  this.$refs.table.clearSelection()
                  this.handleClose()
                  this.$message({
                    type: 'success',
                    message: this.$t('screen.name12')
                  })
                }
              })
              .catch(() => {
                this.loading = false
              })
          }
        } else {
          return false
        }
      })
    },
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.queryList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.queryList()
    }
  }
}
</script>
<style lang="scss" scoped>
.overviewappusers-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .bt-layout {
    display: flex;
    flex-direction: row;
    height: 36px;
  }

  .qiyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}
</style>
